var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navbar",
      class: { navbarPopup: !_vm.closePage && _vm.closePopup },
    },
    [
      _c(
        "div",
        {
          staticClass: "navbar-inner no-swipeback",
          class: { "navbar-inner-popup": !_vm.closePage && _vm.closePopup },
          on: { click: _vm.closeCountryPickerModal },
        },
        [
          _c(
            "f7-nav-left",
            [
              _vm.isSmallScreen
                ? _c("f7-link", {
                    staticClass: "color-grey-page-navbar",
                    attrs: {
                      "icon-fa": "bars",
                      color: "#000000",
                      "close-picker": "",
                      "open-panel": "left",
                      "aria-label": _vm.$t("navigation.menu_label"),
                      role: "button",
                    },
                    on: { click: _vm.updateNotifications },
                  })
                : _c("f7-link", {
                    staticClass: "color-white w-79px",
                    attrs: { "icon-fa": "bars", "aria-hidden": true },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "showSmallScreenOnly titleApp centrageLogoSmallScreen",
            },
            [
              _c(
                "button",
                {
                  staticClass: "logo-button",
                  class: { "streammind-icon-popup": _vm.closePopup },
                  attrs: {
                    type: "button",
                    "aria-label": _vm.$t("navigation.home_label", {
                      service: _vm.service || "DealPrudence",
                    }),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.redirectionPage(_vm.service)
                    },
                  },
                },
                [
                  _c("f7-icon", {
                    staticClass: "streammind-icon",
                    class: _vm.getColor,
                    attrs: { "aria-hidden": true },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.service || "DealPrudence")),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "showSmallScreenOnly titleApp centrageLogoLargeScreen",
            },
            [
              _vm.picker &&
              !_vm.closePopup &&
              _vm.service &&
              _vm.service.length > 4
                ? _c(
                    "button",
                    {
                      staticClass: "logo-button",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("navigation.home_label", {
                          service: _vm.service,
                        }),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.redirectionPage(_vm.service)
                        },
                      },
                    },
                    [
                      _c("f7-icon", {
                        staticClass: "streammind-icon",
                        class: _vm.getColor,
                        attrs: { "aria-hidden": true },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.service)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.closePage && _vm.closePopup
                ? _c(
                    "div",
                    {
                      attrs: {
                        "aria-label": _vm.$t("navigation.current_service", {
                          service: _vm.service || "DealPrudence",
                        }),
                        role: "img",
                      },
                    },
                    [
                      _c("f7-icon", {
                        staticClass: "streammind-icon streammind-icon-popup",
                        class: _vm.getColor,
                        attrs: { "aria-hidden": true },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.service || "DealPrudence")),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.closePopup && !_vm.closePage
            ? _c(
                "div",
                { staticClass: "cancelButton" },
                [
                  _c(
                    "f7-link",
                    {
                      staticClass: "streammindContactListButton orangeFont",
                      attrs: { "close-popup": "" },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cncl")))]
                  ),
                ],
                1
              )
            : _vm.closePage && !_vm.returnPreviousPage
            ? _c(
                "div",
                [
                  _c(
                    "f7-link",
                    {
                      staticClass:
                        "streammindContactListButton cancelButton orangeFont",
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cncl")))]
                  ),
                ],
                1
              )
            : _vm.returnPreviousPage
            ? _c(
                "div",
                [
                  _c(
                    "f7-link",
                    {
                      staticClass:
                        "streammindContactListButton cancelButton orangeFont",
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.rtrn")))]
                  ),
                ],
                1
              )
            : _c("div", [_c("div", { staticClass: "min-w-44px" })]),
          _vm._v(" "),
          _vm.userIsGuest()
            ? _c(
                "f7-nav-right",
                [
                  _vm.picker &&
                  !_vm.closePopup &&
                  !_vm.closePage &&
                  !_vm.returnPreviousPage
                    ? _c("f7-link", {
                        staticClass: "color-silver bg-color-white",
                        attrs: {
                          "no-link-class": "",
                          "icon-fa": "th",
                          "aria-label": _vm.$t(
                            "navigation.service_switcher_disabled"
                          ),
                          "aria-disabled": true,
                          role: "button",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "f7-nav-right",
                [
                  _vm.picker &&
                  !_vm.closePopup &&
                  !_vm.closePage &&
                  !_vm.returnPreviousPage &&
                  _vm.$engine.firstOn().user.validateAccess("serviceSwitcher")
                    ? _c("f7-link", {
                        staticClass: "color-grey",
                        attrs: {
                          "close-picker": "",
                          "icon-fa": "th",
                          "open-popup": "",
                          "data-popup": "#service-switcher-true",
                          "aria-label": _vm.$t(
                            "navigation.service_switcher_label"
                          ),
                          role: "button",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
          _vm._v(" "),
          _vm.subNavTitle !== "" && !_vm.closePage && _vm.closePopup
            ? _c(
                "f7-subnavbar",
                {
                  staticClass:
                    "subtitle-page-navbar subtitlePopup subnavbarPopup",
                  class: "border-bottom-color : " + _vm.color,
                },
                [
                  !_vm.closePage && _vm.closePopup
                    ? _c("div", { staticClass: "subNavtitlePopup" }, [
                        _vm._v(_vm._s(_vm.subNavTitle)),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm.subNavTitle !== ""
            ? _c(
                "f7-subnavbar",
                {
                  staticClass: "subtitle-page-navbar",
                  class: "border-bottom-color : " + _vm.color,
                },
                [
                  _c(
                    "div",
                    { staticClass: "returnButtonMarginLeft" },
                    [
                      _vm.ReturnButton
                        ? _c(
                            "f7-link",
                            {
                              staticClass: "color-grey-page-navbar",
                              attrs: { "close-picker": "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goBack()
                                },
                              },
                            },
                            [
                              _c("f7-icon", {
                                staticClass: "rotate-180deg",
                                attrs: { f7: "play_fill" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "subNavtitle" }, [
                    _vm._v(_vm._s(_vm.subNavTitle)),
                  ]),
                  _vm._v(" "),
                  _vm.popoverName
                    ? _c("div", { staticClass: "popoverNamePaddingRight" })
                    : _c("div", [_c("div", { staticClass: "ml-15px" })]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }